
export default {
  props: {
    result: {
      // 交易商数据
      type: Object,
      default: () => {}
    },
    emailval: {
      // 用户输入的邮箱
      type: String,
      default: ''
    },
    type: {
      // 企业类型-服务商1，交易商2
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      value: '', // 验证值
      showKeyboard: true,
      timenum: 60,
      isagin: true
    }
  },
  watch: {
    value() {
      console.log(this.value, 332)
      if (this.value.length >= 4) {
        this.value = this.value.substring(0, 4)
        console.log(this.value, 332)
        this.showKeyboard = false
        this.$emit('verifyvalfn', this.value)
      }
    }
  },
  mounted() {
    // this.getmanage()
    console.log(345)
    if (!this.$store.state.mobile) {
      document.addEventListener('keydown', this.handleWatchEnter)
    }
  },
  beforeDestroy() {
    console.log(123)
    document.removeEventListener('keydown', this.handleWatchEnter)
  },
  methods: {
    init() {
      this.value = ''
      this.timenum = 60
      this.isagin = false
    },
    inittw() {
      this.value = ''
      if (this.timenum <= 0) {
        this.timenum = 60
        this.isagin = false
      }
    },
    handleWatchEnter(e) {
      const key = window.event ? e.keyCode : e.whichdscsdcdcdscdscscd
      if (key == 8) {
        this.value = this.value.substr(0, this.value.length - 1)
      }
      if (this.value.length >= 4) return
      console.log(key, 112)
      if (key >= 48 && key <= 57) {
        const val = key - 48
        this.value += val
      }
    },
    // 替换邮箱字符
    regEmail(email) {
      let newemail = ''
      if (String(email).indexOf('@') > 0) {
        const str = email.split('@')
        let _s = ''
        if (str[0].length > 3) {
          for (let i = 0; i < str[0].length - 3; i++) {
            _s += '*'
          }
        }
        newemail = str[0].substr(0, 3) + _s + '@' + str[1]
      }
      return newemail
    },
    counttimefn() {
      this.value = ''
      const timer = setInterval(() => {
        if (this.timenum <= 0) {
          this.timenum = 60
          clearInterval(timer)
          this.isagin = false
          this.$emit('starttime')
          return
        }
        this.timenum--
      }, 1000)
    },
    aginfn() {
      this.isagin = true
      this.counttimefn()
      this.$emit('aginfn')
    }
  }
}
